module.exports = __webpack_public_path__ + "img/12-14.22eab791.png";